import React from "react";
import Bluedots from "../../assets/images/blue_dotes.png";
import feature1a from "../../assets/images/feature1a.png";
import feature1b from "../../assets/images/feature1b.png";
import feature2a from "../../assets/images/feature2a.png";
import feature2b from "../../assets/images/feature2b.png";
import feature3a from "../../assets/images/feature3a.png";
import feature3b from "../../assets/images/feature3b.png";

function Task() {
  return (
    <section className="row_am task_app_section">
      <div className="task_block" style={{ top: 100, position: "sticky" }}>
        <div className="dotes_blue">
          <img src={Bluedots} alt="" />
        </div>
        <div className="row">
          <div className="col-md-6">
            <div
              className="task_img"
              data-aos="fade-in"
              data-aos-duration={1500}
            >
              <div className="frame_img">
                <img src={feature1a} alt="" />
              </div>
              <div className="screen_img">
                <img className="moving_animation" src={feature1b} alt="" />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="task_text">
              <div
                className="section_title white_text"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                <span className="title_badge">Features principales</span>
                <span>
                  <h1 style={{ fontSize: "60px" }}>🎯</h1>
                </span>
                <h2>Découvre ton potentiel grâce à des tests intelligents</h2>
                <p>
                  Neoori te propose des jeux et tests conçus pour révéler tes
                  forces, tes talents naturels et ton style d’apprentissage. En
                  quelques minutes, tu obtiens un premier profil personnalisé,
                  simple et clair.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="task_block" style={{ top: 100, position: "sticky" }}>
        <div className="dotes_blue">
          <img src={Bluedots} alt="" />
        </div>
        <div className="row">
          <div className="col-md-6">
            <div
              className="task_img"
              data-aos="fade-in"
              data-aos-duration={1500}
            >
              <div className="frame_img">
                <img src={feature2a} alt="" />
              </div>
              <div className="screen_img">
                <img className="moving_animation" src={feature2b} alt="" />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="task_text">
              <div
                className="section_title white_text"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                <span className="title_badge">Intelligence augmentée</span>
                <span>
                  <h1 style={{ fontSize: "60px" }}>💬</h1>
                </span>
                <h2>Un coach IA qui t’accompagne au quotidien</h2>
                <p>
                  Discute avec ton coach IA, pose-lui des questions, obtiens des
                  conseils adaptés à ton parcours. Il analyse tes réponses, ton
                  profil et tes objectifs pour t’offrir un accompagnement
                  vraiment personnalisé.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="task_block" style={{ top: 100, position: "sticky" }}>
        <div className="dotes_blue">
          <img src={Bluedots} alt="" />
        </div>
        <div className="row">
          <div className="col-md-6">
            <div
              className="task_img"
              data-aos="fade-in"
              data-aos-duration={1500}
            >
              <div className="frame_img">
                <img src={feature3a} alt="" />
              </div>
              <div className="screen_img">
                <img className="moving_animation" src={feature3b} alt="" />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="task_text">
              <div
                className="section_title white_text"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                <span className="title_badge">Personnalisation avancée</span>
                <span>
                  <h1 style={{ fontSize: "60px" }}>🔮</h1>
                </span>
                <h2>Un parcours qui s’adapte à toi, pas l’inverse</h2>
                <p>
                  Neoori te propose des formations, articles, offres et contenus
                  alignés avec ton profil. Chaque recommandation évolue en
                  fonction de tes progrès, de tes envies et de ce qui te motive.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Task;
